export const barChartOptions = (
    hTitle: string,
    chartColors: string[],
    chartType: string,
    chartWith: any[],
    isDrillDownAllowed: boolean,
): {} => {
    let linkStyle = {};
    if (isDrillDownAllowed) {
        linkStyle = {
            cursor: 'pointer',
            color: '#3435A7',
            underline: true,
            linkSuggested: true,
        };
    }

    const width = Number(chartWith.length) > 20 ? Number(chartWith.length) * 50 : 'auto';
    const chartDataArray = chartWith
        .map(v => v.filter(v => !isNaN(v)))
        .map(v => v.filter(v => v > 0))
        .filter(v => v.length > 0);
    const tickValue = chartDataArray?.length || 0;

    return {
        width,
        titleTextStyle: {
            fontSize: 15,
            bold: true,
            left: 10,
        },
        chartArea: {
            top: 50,
            bottom: 100,
            right: 100,
            left: 150,
        },
        colors: chartColors,
        bar: { groupWidth: '90%' },
        legend: 'none',
        chart: {
            textStyle: {
                fontSize: 13,
                bold: true,
            },
        },
        vAxis: {
            title: hTitle,
            titleTextStyle: { italic: false, bold: true },
            minValue: 0,
            ticks: !tickValue ? [0, 1, 2] : null,
            textStyle: {
                fontSize: 13,
            },
            format: '',
        },
        hAxis: {
            textPosition: 'out',
            titleTextStyle: { italic: false, bold: true },
            minValue: 0,
            textStyle: {
                fontSize: 13,
                ...linkStyle,
            },
            slantedText: true,
            showTextEvery: 1,
        },
        axes: {
            y: {
                0: { side: 'right' },
            },
        },
    };
};
